import { connect } from "react-redux"
import SignIn from "./SignIn"
import { compose } from "redux"
import { withSnackbar } from "notistack"
import { privileges } from "constants/auth"
import { accessAllowed } from "utils/auth"
import { signInWithEmailAndPassword } from "../../../store/actions/auth"

const mapStateToProps = (state) => {
	return { authorized: accessAllowed(state.user.privileges, privileges.VIEW) }
}

const mapDispatchToProps = (dispatch) => ({
	signIn: (email, password) => dispatch(signInWithEmailAndPassword(email, password)),
})

export default compose(connect(mapStateToProps, mapDispatchToProps), withSnackbar)(SignIn)
